export default __webpack_public_path__ + "static/media/rehagro_logo_azul.278256ba.png";